import { APIModel } from "app/state/api";
import { ApiCallModel } from "app/state/api/interfaces";

const priorityBarchart: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/priority-bar-chart`),
};

export default priorityBarchart;
